import React from "react";
import Grid from "@material-ui/core/Grid";
import { Field } from "react-final-form";
import { testeRecuperacaoApi, clienteApi } from "../../services/Api";
import {
  List,
  MountEntity,
  CrudForm,
  ListApi,
  FormApi,
  DatePicker,
  Autocomplete,
  loopback,
  Filter,
  autocompleteHelpers,
} from "elentari";
import moment from "moment";
import { TextField } from "final-form-material-ui";
import { getUTCFormatedDate } from "../../utils/dateParse";

const { loopbackFilters } = loopback;
const loadClientes = async (inputValue) => {
  const response = await clienteApi.getList({
    where: {
      nome: loopbackFilters.regexp(inputValue),
    },
    order: "nome asc",
    limit: 40,
  });
  if (response.ok) {
    return response.data.map(autocompleteHelpers.toOption("nome"));
  }
  return [];
};

function TesteRecuperacaoFilter(props) {
  return (
    <Filter
      formatFilters={{ clienteId: (value) => value.id }}
      labels={{ find: "Buscar", clear: "Limpar" }}
    >
      <Grid spacing={24} container>
        <Grid item xs>
          <Field
            label="Cliente"
            loadOptions={loadClientes}
            component={Autocomplete}
            name="clienteId"
          />
        </Grid>
      </Grid>
    </Filter>
  );
}

export function TesteRecuperacaoList(props) {
  const listOptions = {
    defaultOrder: "dataCadastro desc",
    fields: {
      cliente: {
        noOrder: true,
        label: "Cliente",
      },
      dataCadastro: {
        label: "Data",
        format: (date) =>
          date ? moment(getUTCFormatedDate(date)).format("DD/MM/YYYY") : "",
      },
      testeRecuperacao: {
        label: "Teste Recuperação",
      },
    },
  };

  const getPageDecorator = async ({ getPage }) => {
    const items = await getPage();
    if (!items) return;
    const promises = items.map(async (item) => {
      const response = await clienteApi.getOne(item.clienteId);
      if (response.ok) {
        return {
          ...item,
          cliente: response.data.nome,
          clienteId: undefined,
        };
      }
      return item;
    });
    return Promise.all(promises);
  };

  return (
    <ListApi getPageDecorator={getPageDecorator} api={testeRecuperacaoApi}>
      {({ getPage, getCount, handleDelete }) => (
        <div>
          <TesteRecuperacaoFilter />
          <List
            {...props}
            withPaper
            labelNew="Novo"
            deleteItem={handleDelete}
            onClickEdit={(item) =>
              props.history.push(`/teste-recuperacao/${item.id}`)
            }
            onClickNew={() => props.history.push("/teste-recuperacao/new")}
            getPage={getPage}
            getCount={getCount}
            listOptions={listOptions}
          />
        </div>
      )}
    </ListApi>
  );
}

export function TesteRecuperacaoForm(props) {
  const validate = (values) => ({
    cliente: values.cliente ? undefined : "Obrigatório",
    testeRecuperacao:
      values.testeRecuperacao &&
      values.testeRecuperacao >= 0 &&
      values.testeRecuperacao <= 100
        ? undefined
        : "Obrigatório",
  });

  const submitDecorator = async ({ data, id, handleSubmit }) => {
    const result = await handleSubmit({
      id,
      data: {
        ...data,
        testeRecuperacao: +data.testeRecuperacao,
        cliente: undefined,
        clienteId: data.cliente.id,
      },
    });
    return result;
  };

  const getItem = async () => {
    return MountEntity(props, testeRecuperacaoApi.getOne)
      .populate(({ data, id }) => ({
        cliente: clienteApi.getOne(data.clienteId),
      }))
      .clean(["clienteId"])
      .map((data) => ({
        ...data,
        cliente: autocompleteHelpers.toOption("nome")(data.cliente),
        dataCadastro: getUTCFormatedDate(data.dataCadastro),
      }))
      .getItem();
  };

  return (
    <FormApi
      api={testeRecuperacaoApi}
      submitDecorator={submitDecorator}
      {...props}
    >
      {({ handleSubmit }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container direction="column" spacing={16}>
            <Grid item>
              <Grid container spacing={16}>
                <Grid item xs>
                  <Field
                    label="Cliente"
                    loadOptions={loadClientes}
                    component={Autocomplete}
                    name="cliente"
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Field
                    fullWidth
                    component={DatePicker}
                    label="Data Avaliação"
                    name="dataCadastro"
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Field
                    fullWidth
                    component={TextField}
                    label="Teste Recuperação"
                    name="testeRecuperacao"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}
